const INITIAL_STATE = { employees: [] };

const employeesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_EMPLOYEES":
      return { ...state, employees: [...action.payload] };
    case "UPLOAD_EMPLOYEE":
      return {
        ...state,
        employees: [action.payload, ...state.employees],
      };
    case "UPDATE_EMPLOYEE":
      const filteredEmployeeArray = state.employees.filter(
        (employee) => employee.employeeId !== action.payload.employeeId
      );

      return {
        ...state,
        employees: [...filteredEmployeeArray, action.payload],
      };
    case "DELETE_EMPLOYEE":
      const updatedEmployeeArray = state.employees.filter(
        (employee) => employee.employeeId !== action.payload
      );
      return {
        ...state,
        employees: [...updatedEmployeeArray],
      };
    default:
      return { ...state };
  }
};
export default employeesReducer;
